import React from 'react';
import { LAND_AREA_RANGES } from '../constants/filtersOptions';
import SliderInput from './SliderInput';
import { FilterWrapper } from './FilterWrapper';

type LandAreaFilterProps = {
  searchQueryLandAreaRange: Array<number>;
  onChange: (newPriceRange: number[]) => void;
};

export const LandAreaFilter = ({ searchQueryLandAreaRange, onChange }: LandAreaFilterProps) => (
  <FilterWrapper title="Land area">
    <SliderInput
      filterRanges={LAND_AREA_RANGES}
      textInputLabel="(m²)"
      searchQueryRange={searchQueryLandAreaRange}
      onChange={onChange}
    />
  </FilterWrapper>
);
